import { Switch } from "@headlessui/react";
import { useState } from "react";

const ToggleSwitch = ({
  checked,
  onChange,
  className,
  label,
  classNameLabel,
}) => {
  const [isOn, setIsOn] = useState(checked ?? false);

  const handleChange = (value) => {
    setIsOn(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="flex items-center">
      <Switch
        checked={checked ?? isOn}
        onChange={handleChange}
        className={`group inline-flex h-6 w-10 items-center rounded-full bg-gray-200 transition 
        ${checked ?? isOn ? "!bg-[#2D224E]" : "!bg-gray-200"} ${className}`}
      >
        <span
          className={`absolute size-4 translate-x-[-12px] rounded-full bg-white transition 
          ${checked ?? isOn ? "translate-x-[4px]" : ""}`}
        />
      </Switch>
      {/* <span className={`block ml-2 text-sm font-medium ${classNameLabel}`}>
        {checked ?? isOn ? "Active" : "Inactive"}
      </span> */}
      {label && (
        <span className={`block ml-2 font-medium ${classNameLabel}`}>
          {label}
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;
